import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../localization/labels";
import LocalizationUtil from "../../../../localization/LocalizationUtil";
import KnowledgeService from "../../../../services/KnowledgeService";
import PartyMessageService from "../../../../services/PartyMessageService";
import { constants } from "../../../../utils/Constants";
import PathUtil from "../../../../utils/PathUtil";
import SecurityUtils from "../../../../utils/SecurityUtils";
import { paths } from "../../../paths";
import PageComponent from "../../page/PageComponent";
import PartyMessagesDetail from "./PartyMessagesDetail";

class PartyMessagesDetailContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.partyMessageService = new PartyMessageService(this.keycloak);
    this.knowledgeService = new KnowledgeService(this.keycloak);

    this.state = {
      id: this.resolveItemId()
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  componentDidUpdate() {
    const id = this.resolveItemId();
    if (this.state.id !== id) {
      this.setState({ id }, this.loadData);
    }
  }

  loadData = () => {
    if (this.state.id) {
      this.loadPartyMessage(this.state.id);
    } else {
      this.setComponentTitle(labels.partyMessageDetailTitle);
    }
  };

  getComponentTitle = () => {
    return this.state.partyMessage ? this.state.partyMessage.name : undefined;
  };

  loadPartyMessage = id => {
    this.prepareCall(
      this.partyMessageService.postRead(
        id,
        this.onPartyMessageLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onPartyMessageLoad = data => {
    const partyMessage = {
      ...data,
      dispatchDate: LocalizationUtil.localDateTime(data.dispatchDate)
    };
    this.setState({
      partyMessage
    });
    this.setComponentTitle(data.name, true);
    this.loadEntity(data);
  };

  loadEntity = data => {
    if (data._links.entity) {
      const url = data._links.entity.href;
      this.prepareCall(
        this.knowledgeService.getEntitiesByUrl(
          url,
          this.onEntityLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onEntityLoad = data => {
    this.setState({ entity: data });
  };

  openEntity = e => {
    const itemPath = this.createEntityUrl();
    if (itemPath) {
      this.changePath(itemPath, this.state.entity.name);
    }
  };

  openEntityInNewTab = e => {
    const itemPath = this.createEntityUrl();
    if (itemPath) {
      window.open(itemPath, "_blank", "noopener");
    }
  };

  createEntityUrl = () => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(
        this.state.entity,
        constants.OPERATION_READ
      )
    ) {
      return PathUtil.itemPath(paths.KNOWLEDGE_ITEM, this.state.entity.id);
    } else {
      return undefined;
    }
  };

  render() {
    return (
      <PartyMessagesDetail
        partyMessage={this.state.partyMessage}
        entity={this.state.entity}
        openEntity={this.openEntity}
        openEntityInNewTab={this.openEntityInNewTab}
      />
    );
  }
}

export default withKeycloak(PartyMessagesDetailContainer);
